import { render } from "./SafetyVideos.vue?vue&type=template&id=51541995"
import script from "./SafetyVideos.vue?vue&type=script&lang=js"
export * from "./SafetyVideos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__